<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import Paginator, { PageState } from 'primevue/paginator';
    import { computed } from 'vue';

    const props = defineProps<{
        totalRecords: number;
        rows: number;
        first: number;
        page: number;
        pageCount: number;
    }>();

    defineEmits<{
        (e: 'paginationChange', value: PageState): void;
    }>();

    const last = computed(() => {
        return (props.page + 1) * props.rows <= (props.totalRecords ?? 0)
            ? (props.page + 1) * props.rows
            : (props.totalRecords ?? 0);
    });

    const styleVariables = computed(() => {
        return {
            '--last-label': `'${__('pagination-last-label')}'`,
            '--first-label': `'${__('pagination-first-label')}'`,
        };
    });
</script>
<template>
    <div
        :style="styleVariables"
        class="flex items-center justify-between py-3.5 px-6 w-full flex-col lg:flex-row gap-4 border-t border-gray-light"
    >
        <Paginator
            class="p-0 border-0 shadow-none text-sm w-full"
            :rows="rows"
            :first="first"
            :total-records="totalRecords"
            :rows-per-page-options="[10, 25, 50, 100]"
            template="RowsPerPageDropdown FirstPageLink PageLinks LastPageLink"
            @page="$emit('paginationChange', $event)"
        >
            <template #start>
                <span class="h-full">
                    {{
                        __('pagination-current-page-report', {
                            first: (page * rows + 1).toString(),
                            last: last.toString(),
                            totalRecords: totalRecords?.toString() ?? '0',
                        })
                    }}
                </span>
                <span class="h-[40px] border-r border-gray-light w-1" />
                <span class="h-full">{{ __('pagination-rows-per-page-dropdown-show') }}</span>
            </template>
        </Paginator>
    </div>
</template>
